import comp from "./components/CourseSelection";
export default comp;
